import { render, staticRenderFns } from "./StartseitePendenzen.vue?vue&type=template&id=2585d54b&"
import script from "./StartseitePendenzen.vue?vue&type=script&lang=js&"
export * from "./StartseitePendenzen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports